export class ListAzureDiskEncryptionSetsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreApplicationId",
            "baseName": "restoreApplicationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "diskEncryptionSets",
            "baseName": "diskEncryptionSets",
            "type": "Array<AzureDiskEncryptionSet>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureDiskEncryptionSetsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
